// removed by extract-text-webpack-plugin
module.exports = {"img":"app-components-NoDataDisplay-__style___3kGvK","title":"app-components-NoDataDisplay-__style___5AVnj","description":"app-components-NoDataDisplay-__style___2gghB"};


//////////////////
// WEBPACK FOOTER
// ./app/components/NoDataDisplay/style.css
// module id = 2212
// module chunks = 0